import { Trans, useTranslation } from 'react-i18next'

import { Button } from '@ps/ds/components/primitives/Button/Button'
import { Heading } from '@ps/ds/components/primitives/Heading/Heading'
import Error404Image from 'src/assets/Error404.png'
import { NS } from 'src/constants/i18n'
import { EXTERNAL_ROUTES } from 'src/constants/routes'

export const RouteNotFound = () => {
  const { t } = useTranslation(NS.NOT_FOUND)

  return (
    <div className="flex flex-col items-center w-full h-full">
      <div className="flex flex-col items-center md:flex-row md:justify-center">
        <div className="flex flex-col gap-5  lg:min-w-[450px]">
          <Heading size="4xl" className="text-orange-600 lg:text-5xl">
            {t('title')}
          </Heading>
          <p className="text-2xl text-foreground font-bold">{t('subtitle')}</p>
          <p className="text-lg text-gray-600">
            {t('description.line1')}
            <br />
            <Trans
              i18nKey={`${NS.NOT_FOUND}:description.line2`}
              components={{
                contactLink: (
                  <a
                    href={EXTERNAL_ROUTES.MARKETING_ABOUT_US}
                    rel="noopener noreferrer"
                    className="underline"
                  />
                ),
              }}
            />
          </p>

          <div>
            <Button variant="primary" asChild>
              <a href={EXTERNAL_ROUTES.MARKETING_ROOT} rel="noopener noreferrer">
                {t('cta.label')}
              </a>
            </Button>
          </div>

          <p className="text-lg text-gray-600">{t('description.line3')}</p>
        </div>

        <div className="ml-0 z-[-1] md:ml-[-12%] max-w-[350px] md:max-w-[460px] xl:max-w-[760px]">
          <img loading="lazy" width="760" src={Error404Image} alt="" />
        </div>
      </div>
    </div>
  )
}
